module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/companies-admin/companies-list/companies-list.component.css
// module id = ./src/app/companies-admin/companies-list/companies-list.component.css
// module chunks = main